import React from 'react';
// import PropTypes from 'prop-types';
import './Header.css'

import FacebookIconSrc from '../../images/icons/facebook-circle-icon.svg'
import TwitterIconSrc from '../../images/icons/twitter-circle-icon.svg'
import LinkedinIconSrc from '../../images/icons/linkedin-circle-icon.svg'

class Header extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }
  render() {
    return (
      <header className="header" id="header">
        <div className="header-inner">
          <div className="header-left">
            <div className="logo-wrapper">
              <a href="https://corporate.ford.com/homepage.html?intcmp=BFA-Microsite-FMC-CTA-20200515" className="header-logo-mobile" target="_blank" rel="noopener noreferrer" onClick={this.props.trackClick('header-link-click', 'logo')}>
              </a>
            </div>
            <div className="tag-wrapper">
              <p className="tag">#BuiltForProgress</p>
            </div>
          </div>
          <div className="header-right">
            <nav className="navigation">
              <ul className="nav-set">
                <li className="nav-item">
                  <a href="https://corporate.ford.com/homepage.html?intcmp=BFA-Microsite-FMC-CTA-20200515" className="nav-link" target="_blank" rel="noopener noreferrer" onClick={this.props.trackClick('header-link-click', 'back')}>
                  Back To Ford Corporate
                  </a>
                </li>
                <li className="nav-item nav-item-social">
                  <a href="https://www.facebook.com/ford" target="_blank" rel="noopener noreferrer" onClick={this.props.trackClick('header-link-click', 'facebook')}>
                    <img className="social-icon" src={FacebookIconSrc} alt="Facebook Icon"/>
                  </a>
                </li>
                <li className="nav-item nav-item-social">
                  <a href="https://twitter.com/Ford" target="_blank" rel="noopener noreferrer" onClick={this.props.trackClick('header-link-click', 'twitter')}>
                    <img className="social-icon" src={TwitterIconSrc} alt="Twitter Icon"/>
                  </a>
                </li>
                <li className="nav-item nav-item-social">
                  <a href="https://www.linkedin.com/company/ford-motor-company" target="_blank" rel="noopener noreferrer" onClick={this.props.trackClick('header-link-click', 'linkedin')}>
                    <img className="social-icon" src={LinkedinIconSrc} alt='Linkedin Icon'/>
                  </a>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </header>
    );
  }
}

// LoadingSpinner.defaultProps = {
// };
//
//
// LoadingSpinner.propTypes = {
// };
export default Header;
